const IMAGE_SIZES = new Set(['thumbnail', 'medium', 'full'])
const ABSOLUTE_URL_PATTERN = /^https?:\/\//
// Segmen transformasi ImageKit, mis. "/tr:n-ik_full/" pada URL hasil withAssetsUrl.
const IMAGEKIT_TRANSFORM_PATTERN = /\/tr:[^/]+\//

const withAssetsUrl = (path, size = 'thumbnail', oldPath = 'product-images', config) => {
  if (!path) {
    console.warn(`path is empty or missing using withAssetsUrl`)
    return
  }

  if (ABSOLUTE_URL_PATTERN.test(path)) {
    return path
  }

  if (!config) {
    console.error(`config is missing when using withAssetsUrl`)
    return
  }

  if (!IMAGE_SIZES.has(size)) {
    console.error(`unsupported image size for ${size}, only support: ${[...IMAGE_SIZES].toString()}`)
    return
  }

  if (path && (path.indexOf('im__') > -1 || path.indexOf('imagekit__') > -1)) {
    return config.imagekit[size] + path
  }

  return `${config.api.replace('/api', '')}/uploads/${oldPath}/${path}`
}

// [FW-4033] Lebar varian gambar produk Classic. ik_full mentok di sekitar 1024 px, jadi itu batas atasnya.
const PRODUCT_IMAGE_WIDTHS = [480, 640, 800, 1024]
// Di layar lebar slot paling lebar 506 CSS px, tapi hover zoom memperbesar 2x, jadi yang diminta dua kali
// lebar slot supaya zoom tetap tajam. Di HP slot selebar layar dikurangi margin dan padding.
const PRODUCT_IMAGE_SIZES = '(min-width: 576px) 1012px, calc(100vw - 42px)'

// ImageKit merangkai transformasi dengan ":", jadi named transform yang sudah ada tetap dipakai.
const withImageWidth = (url, width) => url.replace(IMAGEKIT_TRANSFORM_PATTERN, (transform) => `${transform.slice(0, -1)}:w-${width}/`)

/**
 * [FW-4033] Atribut gambar produk Classic: <img> dan <link rel=preload> yang memakai fungsi ini
 * mendapat kandidat yang sama, jadi gambar LCP tidak terunduh dua kali.
 * URL non-ImageKit (gambar legacy di /uploads atau URL absolut) dibiarkan tidak berubah.
 */
const getProductImageSources = (url) => {
  if (!url || !IMAGEKIT_TRANSFORM_PATTERN.test(url)) return { src: url }

  return {
    srcset: PRODUCT_IMAGE_WIDTHS.map((width) => `${withImageWidth(url, width)} ${width}w`).join(', '),
    sizes: PRODUCT_IMAGE_SIZES,
    src: withImageWidth(url, PRODUCT_IMAGE_WIDTHS[PRODUCT_IMAGE_WIDTHS.length - 1])
  }
}

export {
  withAssetsUrl,
  getProductImageSources
}
